'use client';

import * as prismic from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import classNames from 'classnames';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import { Accordion, Button } from '@get-mosh/msh-shared';
import { Vertical } from 'src/constants/Verticals';
import { PrismicNextImage } from '@prismicio/next';

type ImageAndContentProps =
    SliceComponentProps<prismic.Content.ImageAndContentSlice> & {
        context: {
            pageType: string;
        };
    };

const ImageAndContent = ({ slice, context }: ImageAndContentProps) => (
    <section
        className="py-8 md:py-20"
        style={{
            backgroundColor: slice.primary.background ?? 'bg-white',
        }}
    >
        <div className="container flex h-full flex-col items-center gap-12 sm:flex-row">
            <div
                className={classNames(
                    !slice.primary.align_image
                        ? 'order-1 lg:mx-10 xl:mx-14'
                        : '',
                    'flex h-full flex-1 flex-col items-start justify-start',
                )}
            >
                {slice?.primary?.icon?.url && (
                    <picture className="mb-3 hidden md:block">
                        <PrismicNextImage
                            field={slice.primary.icon}
                            height={73}
                            width={73}
                        />
                    </picture>
                )}
                <div className="flex flex-col gap-4">
                    {slice?.primary?.title && <h2>{slice.primary.title}</h2>}
                    <PrismicRichText field={slice?.primary?.description} />

                    {slice?.items?.length > 0 &&
                        slice.items[0].accordion_title && (
                            <Accordion
                                items={slice.items.map((item) => {
                                    return {
                                        title: item.accordion_title ?? '',
                                        content: prismic.asHTML(
                                            item.accordion_content,
                                        ),
                                    };
                                })}
                                className="mb-8 md:mb-0"
                            />
                        )}
                </div>
                {slice?.primary?.link_path && (
                    <Button
                        text={slice.primary.link_label ?? 'Learn More'}
                        as="a"
                        href={slice.primary.link_path}
                        onClick={() => {
                            trackClick(EventNames.BUTTON_CLICKED, {
                                pageType: context.pageType,
                                vertical: slice.primary.vertical as Vertical,
                                label: slice.primary.link_label ?? 'Learn More',
                                link: slice.primary.link_path ?? '',
                                variation: slice.variation,
                                location: slice.slice_type,
                            });
                        }}
                        className="mb-4 mt-6"
                    />
                )}
            </div>
            {slice.primary.image.url && (
                <div className="flex-1">
                    <PrismicNextImage field={slice.primary.image} />
                </div>
            )}
        </div>
    </section>
);

export default ImageAndContent;
